/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Backtoevent2Inputs */

const en_backtoevent2 = /** @type {(inputs: Backtoevent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to the event`)
};

const de_backtoevent2 = /** @type {(inputs: Backtoevent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück zum Event`)
};

/**
* | output |
* | --- |
* | "Back to the event" |
*
* @param {Backtoevent2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const backtoevent2 = /** @type {((inputs?: Backtoevent2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Backtoevent2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_backtoevent2(inputs)
	return de_backtoevent2(inputs)
});
export { backtoevent2 as "backToEvent" }